// web/src/shell/useIsMobileViewport.ts
//
// Single source of truth for "is this a mobile viewport?" Used by
// <MobileGate /> to decide whether to show the desktop-only-warning
// interstitial in place of the trading dashboard.
//
// Breakpoint: 768px (Tailwind's `md`). The trading view's two-pane
// layout falls apart well before that, but rather than pick a tighter
// number we err on the side of "if your screen is under 768px, you'd
// hate this experience anyway."
import { useEffect, useState } from "react";

const MOBILE_MEDIA_QUERY = "(max-width: 768px)";

export function useIsMobileViewport(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    // SSR / jsdom may not have matchMedia. Default to "not mobile" so
    // the desktop experience renders by default when the API is absent.
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia(MOBILE_MEDIA_QUERY).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia(MOBILE_MEDIA_QUERY);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    // Use addEventListener over the deprecated addListener.
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  return isMobile;
}
